import React, { Component } from "react";

class SentMessagesRow extends Component {
  constructor(props) {
    super(props);
    this.state = { stats: { received: "", sent: "" } };
  }
  componentDidMount() {
    fetch("/message/stats/?moment=" + this.props.sentmessage[0])
      .then(
        response => {
          return response.json();
        },
        err => {
          console.log("error", err);
        }
      )
      .then(data => {
        this.setState({ stats: data });
      });
  }

  render() {
    //console.log("SentMessagesRow: " + this.props.sentmessage[0]);

    let new_datestring = new Date(this.props.sentmessage[0])
      .toLocaleString()
      .split(" ");
      
    return (
      <tr>
        <td>{new_datestring[0]}</td>
        <td>{new_datestring[1]}</td>
        <td>{this.props.sentmessage[1]}</td>
        <td>{this.state.stats.sent}</td>
        <td>{this.state.stats.received}</td>
        <td>{this.state.stats.confirmed}</td>
        <td>
          <button
            type="submit"
            className="btn btn-info btn-sm"
            data-toggle="modal"
            data-target="#messageModal"
            onClick={() => {
              console.log("Model button geklikt. ");
              console.log(this.props.sentmessage);
              this.props._callbackStateModal(this.props.sentmessage);
            }}
          >
            Show stats{" "}
          </button>
        </td>
      </tr>
    );
  }
}

export default SentMessagesRow;
